import { render, staticRenderFns } from "./BosButton.vue?vue&type=template&id=adf2d446&scoped=true"
import script from "./BosButton.vue?vue&type=script&lang=js"
export * from "./BosButton.vue?vue&type=script&lang=js"
import style0 from "./BosButton.vue?vue&type=style&index=0&id=adf2d446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf2d446",
  null
  
)

export default component.exports